module.exports = __webpack_public_path__ + "img/report_image_2.04e02670.png";